import { Button, Footer, Link } from '@purpurds/purpur';
import { useTranslation } from 'react-i18next';

//@ts-ignore
import { ReactComponent as TeliaFooterIcon } from './TeliaFooterIcon.svg';

import './TheFooter.scss';

function cookieSettingsScriptInit() {
  // @ts-ignore
  window.OneTrust.ToggleInfoDisplay();
}

export const TheFooter = () => {
  const { t, i18n } = useTranslation();
  const cookieListUrl = `/${i18n.language}/${t('link_articles')}/${t('footer.cookies.slug')}`;
  const linkedinLink = 'https://www.linkedin.com/company/teliacompany/posts/?feedView=all';

  const getFooterLinks = () => {
    return [
      {
        heading: t('footer.contact_us'),
        links: [
          {
            href: `/${i18n.language}/${t('link_articles')}/${t(
              'navigation.markets_and_brands.slug'
            )}`,
            text: t('footer.our_brands'),
          },
          {
            href: `/${i18n.language}/${t('link_articles')}/${t('navigation.press_and_media.slug')}`,
            text: t('navigation.press_and_media.title'),
          },
          {
            href: `/${i18n.language}/${t('navigation.investors.slug')}`,
            text: t('navigation.investor_relations.title'),
          },
        ],
      },
      {
        heading: t('footer.quick_links'),
        links: [
          {
            href: `/${i18n.language}/${t('link_articles')}/${t('navigation.privacy.slug')}`,
            text: t('navigation.privacy.title'),
          },
          {
            href: `/${i18n.language}/${t('link_articles')}/${t(
              'footer.telia_copmany_in_brief.slug'
            )}`,
            text: t('footer.telia_copmany_in_brief.title'),
          },
          {
            href: `/${i18n.language}/${t('link_careers')}/${t('navigation.open_positions.slug')}`,
            text: t('open_positions'),
          },
          {
            href: `/${i18n.language}/${t('navigation.reports_and_presentations.slug')}`,
            text: t('footer.financial_reports_and_presentations'),
          },
        ],
      },
      {
        heading: t('footer.about_this_site'),
        links: [
          {
            href: `/${i18n.language}/${t('link_articles')}/${t(
              'footer.terms_and_conditions.slug'
            )}`,
            text: t('footer.terms_and_conditions.title'),
          },
          {
            href: `/${i18n.language}/${t('link_articles')}/${t(
              'footer.accessibility_statement.slug'
            )}`,
            text: t('footer.accessibility_statement.title'),
          },
        ],
      },
    ];
  };

  return (
    <Footer
      logo={
        <a href={`/${i18n.language}`} aria-label={t('footer.telia_icon')}>
          <TeliaFooterIcon className="footer__logo" />
        </a>
      }
      contacts={{
        copyright: '© Telia Company AB 556103-4249 Stjärntorget 1 Solna',
      }}
      custom={{
        content: (
          <div className="footer__consent-list">
            <Button
              variant="text"
              negative
              className="consent-list__cookie-settings"
              onClick={cookieSettingsScriptInit}
              aria-label={t('footer.cookies_settings')}
            >
              {t('footer.cookies_settings')}
            </Button>
            <Link variant="text" className="consent-list__item-value" href={cookieListUrl} negative>
              {t('footer.cookies.title')}
            </Link>
          </div>
        ),
        sectionProps: {
          'aria-label': 'Cookie settings and policy links',
        },
      }}
      navigation={{
        links: getFooterLinks(),
        sectionProps: {
          'aria-label': 'Navigation links',
        },
      }}
      social={{
        links: [
          {
            'aria-label': "Link to Telia's LinkedIn page",
            href: linkedinLink,
            icon: {
              name: 'linkedin',
              svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M4.024 1.5A2.526 2.526 0 0 0 1.5 4.027a2.526 2.526 0 0 0 2.524 2.528 2.527 2.527 0 0 0 2.522-2.528A2.526 2.526 0 0 0 4.024 1.5ZM17.28 8.124c-2.118 0-3.537 1.163-4.118 2.265h-.058V8.473H8.929V22.5h4.349v-6.94c0-1.829.346-3.601 2.611-3.601 2.232 0 2.263 2.092 2.263 3.72v6.82h4.347v-7.693c0-3.777-.813-6.682-5.22-6.682ZM6.2 22.5H1.848V8.473H6.2V22.5Z"/></svg>',
            },
          },
        ],
        sectionProps: {
          'aria-label': 'Social media links',
        },
      }}
    />
  );
};
